import ProductIntroTitle from './ProductIntroTitle'
import communication from './Communication/communication.png'
import { motion } from 'framer-motion'

const title = 'Seamless coordination'

const Communication = () => (
  <motion.section className="grid grid-cols-1 sm:grid-cols-[auto_22rem] xl:grid-cols-[auto_33rem] items-center gap-y-8 gap-x-16">
    <figure className="sm:hidden order-2 relative w-full">
      <div className="relative w-[109vw] -left-[14vw]">
        <img src={communication} className="w-full h-full object-cover" alt={title} />
      </div>
    </figure>

    <motion.figure className="relative hidden sm:block h-[29rem] xl:h-[39.9375rem] mt-4 sm:mt-0">
      <motion.div className="hidden sm:block absolute inset-y-0 w-[45rem] xl:w-[58.375rem] -right-[2rem]">
        <motion.img
          src={communication}
          className="object-contain"
          alt={title}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-200px 1px' }}
          transition={{ duration: 0.5 }}
          variants={{
            visible: {
              opacity: 1,
              x: 0,
              transition: { type: 'spring', stiffness: 300, damping: 24 },
            },
            hidden: { opacity: 0, x: -200 },
          }}
        />
      </motion.div>
    </motion.figure>

    <div className="pb-auto sm:pb-8 xl:pb-12 space-y-4 sm:space-y-8 w-full sm:w-[22rem] xl:w-[34.75rem] text-center sm:text-left order-1 sm:order-2">
      <div className="space-y-2 sm:space-y-4">
        <div className="flex justify-center sm:justify-start">
          <ProductIntroTitle>For Everyone</ProductIntroTitle>
        </div>
        <h3 className="font-medium text-xl sm:text-3xl leading-6 sm:leading-9">{title}</h3>
      </div>
      <p className="text-base sm:text-lg leading-6 sm:leading-7">
        Coordinate with your team and vendors on every order without making a single call.
      </p>
    </div>
  </motion.section>
)

export default Communication
